export const nav = {
  home: 'ホーム',
  services: 'サービス',
  solutions: 'ソリューション',
  tools: 'ツール',
  about: '会社概要',
  contact: 'お問い合わせ',
  requestQuote: '見積もり依頼'
};

export const hero = {
  title1: '国際海上輸送',
  title2: 'ソリューション',
  title3: 'カンパニー',
  description: '最先端技術と比類なき専門知識により、海上貨物サービスの卓越性を提供します。信頼性が高く、効率的で持続可能な海上ソリューションを通じて、お客様のビジネスを世界とつなぎます。',
  exploreServices: 'サービスを見る',
  getStarted: '始める',
  vessels: '隻以上',
  countries: 'カ国',
  support: 'サポート'
};

export const services = {
  title: '私たちのサービス',
  subtitle: 'ビジネス関係と物流効率を向上させるために設計された包括的な海事サービス',
  consulting: {
    title: 'コンサルティングサービス',
    description: '海運業務とサプライチェーン戦略を最適化するための専門的な海事コンサルティング'
  },
  portTour: {
    title: 'ポートツアーサービス',
    description: 'ロサンゼルス港とロングビーチ港のコンテナターミナルの包括的なガイドツアー'
  },
  seminar: {
    title: '業界セミナー',
    description: '海上輸送における最新のトレンド、規制、ベストプラクティスをカバーする教育セミナー'
  },
  logisticsInfo: {
    title: '物流情報ハブ',
    description: '貴重なリアルタイム物流データ、市場インサイト、業界インテリジェンスへのアクセス'
  },
  routing: {
    title: '輸送ルーティング',
    description: '貨物ニーズに最適化された信頼性の高い効率的な輸送ルートのご紹介'
  },
  solutions: {
    title: '物流ソリューション',
    description: '物流業務の効率を高め、コストを削減する革新的なソリューション'
  },
  relationship: {
    title: '顧客関係構築',
    description: 'ビジネスネットワークを強化するための顧客間の接続とパートナーシップの促進'
  }
};

export const solutionsSection = {
  tag: 'コンサルティング',
  title1: 'お客様のビジネス',
  title2: '課題に合わせた',
  title3: 'カスタマイズソリューション',
  description: '当社の専門コンサルタントは、お客様と緊密に協力して独自の要件を理解し、効率を高め、コストを削減し、グローバル市場での競争優位性を強化するカスタマイズソリューションを開発します。',
  scheduleConsultation: 'コンサルテーション予約',
  learnMore: '詳細を見る',
  visibility: {
    title: 'サプライチェーンの可視化',
    description: 'サプライチェーン全体にわたる貨物のリアルタイム追跡と監視',
    feature1: 'ライブGPS追跡',
    feature2: '自動アラート',
    feature3: '履歴データ'
  },
  costOptimization: {
    title: 'コスト最適化',
    description: 'インテリジェントなルート計画と統合により配送コストを削減',
    feature1: '料金比較',
    feature2: 'ボリューム割引',
    feature3: 'コスト分析'
  },
  riskManagement: {
    title: 'リスク管理',
    description: '貨物の包括的な保険とリスク軽減戦略',
    feature1: '貨物保険',
    feature2: 'コンプライアンス監視',
    feature3: 'リスク評価'
  }
};

export const tools = {
  title: '強力なツール',
  subtitle: '配送業務を効率化する高度な技術ソリューション',
  containerTracking: {
    name: 'コンテナ追跡システム',
    description: 'すべての主要船会社でコンテナをリアルタイムで追跡'
  },
  rateCalculator: {
    name: '料金計算機',
    description: '高度な計算機で配送ニーズの即時見積もりを取得'
  },
  documentation: {
    name: '文書ポータル',
    description: '1つの安全なデジタルプラットフォームですべての配送文書を管理'
  },
  analytics: {
    name: '分析ダッシュボード',
    description: '強力な分析とインサイトで配送データを可視化'
  },
  tryNow: '今すぐ試す',
  requestDemo: 'デモアクセスをリクエスト'
};

export const about = {
  title: 'SHIPFANについて',
  description1: '海上輸送で20年以上の経験を持つSHIPFANは、信頼性、革新性、顧客中心のサービスで評判を築いてきました。当社の海事専門家チームは、深い業界知識と最先端技術を組み合わせて、期待を超えるソリューションを提供します。',
  description2: '日本の海運情報紙である「日本海事新聞」社と連携し米国内の物流情報や市場、各種イベントなどを「ロサンゼルス便り」として毎月定期的に掲載している。',
  mission: '私たちの使命',
  missionText: '革新、持続可能性、顧客の成功への揺るぎないコミットメントを通じて、海上輸送に革命を起こすこと。'
};

export const contact = {
  title: 'お問い合わせ',
  description: '海上輸送を最適化する準備はできていますか？今すぐSHIPFANの専門家チームにお問い合わせいただき、お客様のビジネスの成功をどのようにサポートできるかをご確認ください。',
  email: 'メール',
  phone: '電話',
  office: 'オフィス',
  form: {
    fullName: '氏名',
    fullNamePlaceholder: '山田太郎',
    emailAddress: 'メールアドレス',
    emailPlaceholder: 'yamada@example.com',
    company: '会社名',
    companyPlaceholder: 'あなたの会社',
    serviceInterest: 'サービスへの関心',
    selectService: 'サービスを選択',
    message: 'メッセージ',
    messagePlaceholder: '配送ニーズについてお聞かせください...',
    maxCharacters: '最大500文字',
    sendMessage: 'メッセージを送信',
    sending: '送信中...',
    successMessage: 'ありがとうございます！メッセージは正常に送信されました。すぐにご連絡いたします。',
    errorMessage: '申し訳ございません。メッセージの送信中にエラーが発生しました。もう一度お試しください。'
  }
};

export const footer = {
  tagline: '信頼できる海上輸送ソリューションで世界をつなぐ',
  services: 'サービス',
  solutions: 'ソリューション',
  company: '会社',
  resources: 'リソース',
  careers: '採用情報',
  news: 'ニュース',
  documentation: 'ドキュメント',
  support: 'サポート',
  faq: 'よくある質問',
  copyright: '© 2024 SHIPFAN. All rights reserved.',
  privacyPolicy: 'プライバシーポリシー',
  termsOfService: '利用規約',
  websiteBuilder: 'ウェブサイトビルダー'
};
